import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-kindergarten-banner',
  templateUrl: './kindergarten-banner.component.html',
  styleUrls: ['./kindergarten-banner.component.scss']
})
export class KindergartenBannerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
